import CtaButtonDefault from '../CtaButton'
import emitOnClick from '@cred/react-analytics/hoc/emitOnClick'
import emitGAOnClick from '@cred/shared/hoc/emitGAOnClick'
import withCtaClickEvent from '@cred/react-analytics/hoc/withCtaClickEvent'

const CtaButton = withCtaClickEvent(emitOnClick(emitGAOnClick(CtaButtonDefault)))

export default CtaButton
